import { Entity } from '@/store/shared/entity'

export default class exportProfit extends Entity<number>{
    shippingNumber: string;
    shipmentDate: Date;
    shipmentDateStr: string;
    customerName: string;
    ownerName: string;
    businessGroup: string;
    receiverAmount: number;
    factoryName: Array<any> = new Array<any>();
    factoryAmount: number;
    /// <summary>
    /// 运费
    /// </summary>
    freight: number;
    drawback: number;
    exchangeRate: number;
    amountReceivedUSD: number;
    amountReceivedRMB: number;
    bankCharges: number;
    profitType: string;
    profit: number;
    profitMargin: number;
    remark: string;


}